import { useEffect, useState } from "react";
import { serverAddress } from "../../constant";

const StudentInfo = ({ data }) => {
  const [key, setKey] = useState("");
  const [abstractVisibility, setAbstractVisibility] = useState(false);

  useEffect(() => {
    if (data?.downloadLink) {
      try {
        const url = new URL(data.downloadLink);
        setKey(url.pathname.slice(1));
      } catch (e) {
        setKey("");
      }
    }
  }, [data?.downloadLink]);

  useEffect(() => {
    // console.log(data);
  }, [key]);

  const handleViewAbstract = () => {
    setAbstractVisibility(!abstractVisibility);
  };

  return (
    <>
      {data && data._id && (
        <div
          className="lead-remarks mx-3"
          style={{ marginTop: "96px", height: "100vh", overflowY: "auto", fontFamily: 'Inter' }}
        >
          <div className="">
            <div
              className=""
              style={{
                fontSize: "22px",
                fontWeight: "500",
                paddingLeft: "22px",
              }}
            >
              PERSONAL INFORMATION
            </div>
            <div
              className=""
              style={{
                marginInline: "15px",
                marginTop: "5px",
                height: "2px",
                backgroundColor: "#E5E9EB",
                width: "97%",
              }}
            >
              {" "}
            </div>
          </div>

          <div className="col-md-10 mt-3">
            <div className="spContent31 mx-3">
              <div className="lpContent32">Name :</div>
              <div className="lpContent33">
                {data.firstName} {data.lastName}
              </div>
            </div>

            <div className="spContent31 mx-3">
              <div className="lpContent32">Mobile :</div>
              <div className="lpContent33">{data?.mobile}</div>
            </div>

            <div className="spContent31 mx-3">
              <div className="lpContent32">E-mail :</div>
              <div className="lpContent33">{data?.email}</div>
            </div>

            <div className="spContent31 mx-3">
              <div className="lpContent32">Designation :</div>
              <div className="lpContent33">{data?.designation}</div>
            </div>

            <div className="spContent31 mx-3">
              <div className="lpContent32">Institute :</div>
              <div className="lpContent33">{data?.institute}</div>
            </div>

            <div className="spContent31 mx-3">
              <div className="lpContent32" style={{ minWidth: "150px" }}>Institute Address :</div>
              <div className="lpContent33" style={{ wordBreak: "break-word" }}>{data?.instituteAddress}</div>
            </div>

            <div className="spContent31 mx-3">
              <div className="lpContent32">University:</div>
              <div className="lpContent33">{data?.university}</div>
            </div>

            <div className="spContent31 mx-3">
              <div className="lpContent32">District:</div>
              <div className="lpContent33">{data?.district}</div>
            </div>

            <div className="spContent31 mx-3">
              <div className="lpContent32">State :</div>
              <div className="lpContent33">{data.state} </div>
            </div>

            <div className="spContent31 mx-3">
              <div className="lpContent32">Country :</div>
              <div className="lpContent33">{data?.country}</div>
            </div>

            <div className="spContent31 mx-3">
              <div className="lpContent32">Nationality :</div>
              <div className="lpContent33">{data?.nationality}</div>
            </div>

            <div className="spContent31 mx-3">
              <div className="lpContent32" style={{ minWidth: "150px" }}>Postal Address :</div>
              <div className="lpContent33" style={{ wordBreak: "break-word" }}>{data?.postalAddress}</div>
            </div>

            <div className="spContent31 mx-3">
              <div className="lpContent32">Category:</div>
              <div className="lpContent33">{data?.category}</div>
            </div>

            <div className="spContent31 mx-3">
              <div className="lpContent32" style={{ minWidth: "150px" }}>Paper Title :</div>
              <div className="lpContent33" style={{ wordBreak: "break-word" }}>{data?.paperTitle}</div>
            </div>

            <div className="spContent31 mx-3">
              <div className="lpContent32 font-bold mb-2 " style={{ minWidth: "150px" }}>Co-Authors:</div>
              {data?.coAuthors?.length > 0 ? (
                data.coAuthors.map((coauthor, index) => (
                  <div key={index} className="mb-4">
                    <div className="lpContent33">
                      <strong>Name:</strong> {coauthor.name}
                    </div>
                    <div className="lpContent33">
                      <strong>Email:</strong> {coauthor.email}
                    </div>
                    <div className="lpContent33">
                      <strong>Mobile:</strong> {coauthor.number || coauthor.mobile}
                    </div>
                  </div>
                ))
              ) : (
                <div className="lpContent33">No co-authors available.</div>
              )}
            </div>

            <div className="spContent31 mx-3">
              <div className="lpContent32">Payment Status:</div>
              <div className="lpContent33">{data?.paymentStatus}</div>
            </div>

            <div className="d-flex flex-column gap-5">
              <div className="spContent31 mx-3">
                <div className="lpContent32" style={{ minWidth: "150px", marginRight:"4px" }}>Abstract :</div>
                <div className="lpContent33">
                  {!abstractVisibility && (
                    <span onClick={() => handleViewAbstract()}>
                      <a href="#" style={{ color: "#663399" }}>
                        View
                      </a>
                    </span>
                  )}
                  {abstractVisibility && (
                    <span onClick={() => handleViewAbstract()}>
                      <a href="#" style={{ color: "#663399" }}>
                        Hide
                      </a>
                    </span>
                  )}
                  |
                  <span>
                    <a
                      target="_blank"
                      href={key ? `${serverAddress}/job_application/preview?file_path=${key}` : "#"}
                      style={{ color: "#663399" }}
                      rel="noreferrer"
                    >
                      Download
                    </a>
                  </span>
                </div>

                {abstractVisibility && key && (
                  <iframe
                    width="100%"
                    height="900"
                    className="mx-auto d-flex"
                    src={`${serverAddress}/job_application/preview?file_path=${key}`}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default StudentInfo;
